/** @module Specification/CareAndComposition/CareSymbolPerLanguageRendererMixin */
define([
    "dojo/_base/declare"
], function(declare) {

    return declare(null, {
        
        /**
         * Change index to sys id language
         * @param {Context} ctx
         * @param {Heading} h
         */
        reserveContext: function(ctx, h) {
            ctx.keyValue = ctx.getNodeContext().SysID;
        },
        
        /**
         * Remove index added above
         * @param {Context} ctx
         * @param {Heading} h
         */
        releaseContext: function(ctx, h) {
            ctx.keyValue = null;
        },
        
        /**
         * Disable filtering
         * @param {Context} ctx
         * @param {Heading} h
         * @param {Spec} spec
         */
        getQuerySpec: function(ctx, h, spec) {
            return null;
        }

    });
});